const DURATION = 0.68;
const quiet = () => ({ x: 0, y: 0, z: 0, pitch: 0, roll: 0 });

/** Grounded Cinder load transfer in camera-local metres/radians. Only128's
 * actual supported source contact can start this finite damped response. Its
 * active-time projection is deterministic on pause, replay, resize and retry.
 * Reduced motion retains the visible source collapse/frost/injury, with a
 * completely stable camera and no screen flash or additional rendering pass.
 */
export function skyMassImpactFrame(state, reduced = false) {
  const boss = state.boss,
    contact = boss?.cinderheart?.groundImpact;
  if (reduced || boss?.worldId !== 'cinderheart' || contact?.kind !== 'supported-collapse')
    return quiet();
  const age = boss.age - contact.at;
  if (
    !Number.isFinite(age) ||
    age < 0 ||
    age >= DURATION ||
    !Number.isFinite(contact.clearance) ||
    Math.abs(contact.clearance) > 0.35
  )
    return quiet();
  const envelope = Math.exp(-age * 5) * (1 - age / DURATION) ** 2;
  const down = Math.sin(age * 34) * envelope;
  const recoil = Math.sin(age * 25) * envelope;
  const side = contact.side < 0 ? -1 : 1;
  return {
    x: side * 0.075 * recoil,
    y: -0.18 * down,
    z: 0.055 * recoil,
    pitch: 0.004 * down,
    roll: side * 0.008 * recoil,
  };
}

/** Apply after the caller rebuilds its base camera, before ballistic sight
 * projection. No state or aim target is mutated, and no drawable is allocated.
 * A caller must not accumulate this offset onto last frame's shifted camera.
 */
export function applySkyMassImpact(camera, state, reduced = false, enabled = true) {
  if (!enabled || reduced) return;
  const frame = skyMassImpactFrame(state, reduced);
  if (!frame.x && !frame.y && !frame.z && !frame.pitch && !frame.roll) return;
  camera.translateX(frame.x);
  camera.translateY(frame.y);
  camera.translateZ(frame.z);
  camera.rotateX(frame.pitch);
  camera.rotateZ(frame.roll);
}
